import React from 'react'
import './SwingLoad.css'
const SwingLoad = () => {
    return (
        <div className="flex justify-center mt-10">
            <div className="newtons-cradle">
                <div className="newtons-cradle__dot"></div>
                <div className="newtons-cradle__dot"></div>
                <div className="newtons-cradle__dot"></div>
                <div className="newtons-cradle__dot"></div>
            </div>
        </div>
    )
}

export default SwingLoad
